import React, { useContext } from "react";
import { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Global, { saveReadedOrder, saveUnreadedOrders } from "../../util/Global";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import { LoaderComponent } from "../../util/Loader";
import { AlertContext } from "../../util/Alerter";
import OrderSaleDetail from "../../components/OrdersSales/OrderSaleDetail";
import { useTranslation } from "react-i18next";
import NotFound from "../../components/NotFound";




const CommandDetails = ({ isAdmin }) => {
  const { id } = useParams();
  const { t } = useTranslation()
  const [order, setorder] = useState();
  const [isLoading, setisLoading] = useState(true);


  const { showAlert } = useContext(AlertContext)
  const { countUnreadedOrders, setcountUnreadedOrders, setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)

  const COMMANDE_DETAILS_URL = Global.backend + "/index.php/api/commande/show";



  useEffect(() => {
    if (isAdmin) {
      setpageNavLink({ path: "/dashboard/admin", label: "adminDashboard" })
      setnavLinks([{ path: "/dashboard/admin/orders", label: "orders" }])
    } else {
      setpageNavLink({ path: "/dashboard", label: "navigation12.1" })
      setnavLinks([{ path: "/dashboard/user/mesCommandes", label: "myOrders" }])
    }
    setpageTitle("orderDetails")
    setalertTitle("")
  }, [])



  useEffect(() => {
    setisLoading(true)
    axios.post(COMMANDE_DETAILS_URL, { commandeId: id }).then((response) => {
      // mark as read
      if (saveReadedOrder(id)) {
        setcountUnreadedOrders(countUnreadedOrders - 1)
        saveUnreadedOrders(countUnreadedOrders - 1)
      }

      if (response.data) {
        const order = response.data

        if (order.statut_commande == "refund") {
          setalertTitle(t("refundCustomerAlert"))
        }
        setorder(order)
      }
    }).catch((err) => {
      showAlert("error", t("request.errorFetchingOrderDetails"))
    })
      .finally(() => {
        setisLoading(false);
      });
  }, []);






  return (
    <LoaderComponent isLoading={isLoading}>
      {!isLoading &&
        (!order ? <NotFound /> : <OrderSaleDetail passedData={order} isOrder={true} />)
      }
    </LoaderComponent>
  );
};

export default CommandDetails;
